<template>
    <form @submit.prevent="updatePassword">
        <base-card>
            <template #header>
                {{ $t('auth.password') }}
            </template>
            <template #body>
                <div class="space-y-4">
                    <input-group v-model="form.current_password" name="current_password" type="password"
                                 :label="$t('auth.current_password')" :form="form"/>
                    <input-group v-model="form.password" name="password" type="password"
                                 :label="$t('auth.password')" :form="form"/>
                    <input-group v-model="form.password_confirmation" name="password_confirmation" type="password"
                                 :label="$t('auth.password_confirmation')" :form="form"/>
                </div>
            </template>
            <template #footer>
                <div class="flex space-x-2 justify-end">
                    <save-button/>
                </div>
            </template>
        </base-card>
    </form>
</template>

<script>
export default {
    data() {
        return {
            form: this.$inertia.form({
                current_password: '',
                password: '',
                password_confirmation: '',
            }),
        };
    },

    methods: {
        updatePassword() {
            this.form.put(route('user-password.update'), {
                preserveScroll: true,
            });
        },
    },
};
</script>
